// extracted by mini-css-extract-plugin
module.exports = {"barContainer":"MayPSearchStore_barContainer__3_W8H","embeddedBarContainer":"MayPSearchStore_embeddedBarContainer__2UDOL"};